import { Shield } from "lucide-react";
import { BRAND } from "../lib/brandConfig";

const CLPBanner = () => {
  return (
    <div
      className="bg-[#0A2342]/5 border-b border-[#0A2342]/10 px-4 py-2.5"
      data-testid="clp-banner"
    >
      <div className="container-main flex items-center justify-center gap-2 text-center">
        <Shield className="w-4 h-4 text-[#0A2342] shrink-0" />
        <p className="text-xs sm:text-sm text-[#0A2342]/80">
          Working with an agent? Please list{" "}
          <span className="font-semibold text-[#0A2342]">{BRAND.agentAttribution}</span>{" "}
          on your guest card so I can assist you.
        </p>
      </div>
    </div>
  );
};

export default CLPBanner;
